module.exports = __webpack_public_path__ + "static/media/redirect.8ff437a7.svg";